import jsonLogic from "json-logic-js";

export default function(){
    this.active = function active(){
        if(!this.rule.hasOwnProperty("active"))
            return true;
        let isActive = this.rule.active;
        if(typeof isActive === "object"){
            return jsonLogic.apply(isActive, this.source);
        }
        return isActive;
    };
};
